<div>
    <p class="title">Are you sure to reboot the devices?</p>
    <div class="border px-2">{{ _monitorDeviceNames }}</div>
</div>